import { render, staticRenderFns } from "./Effective.vue?vue&type=template&id=30a91216&"
import script from "./Effective.vue?vue&type=script&lang=js&"
export * from "./Effective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports